import { API } from "./api";

export function reportFrontendFailure() {
  // Deliberately send no exception text, component tree, URL, identity, or CRM data.
  // The backend emits a generic, alertable Sentry event after validating the origin.
  if (typeof fetch !== "function") return;
  fetch(`${API}/monitoring/frontend-error`, {
    method: "POST",
    credentials: "include",
    keepalive: true,
  }).catch(() => {
    // Monitoring must never create another user-facing failure.
  });
}
